import Cookies from "js-cookie";
import CryptoJS from "crypto-js";
import axios from "./axiosConfig";
import Notification from "./Notification";

const Helper = () => {
  const ErrorHanlder = (error) => {
    if (error.response.status === 401) {
      Cookies.set("auth-token", "");
      window.location.href = "/";
    }

    if (axios.isAxiosError(error)) {
      if (error.response?.data?.message) {
        Notification.error(error.response.data.message);
      } else {
        Notification.error("Somthing went wrong");
      }
    }
  };

  const UserRole = () => {
    let roldeId = localStorage.getItem("items");
    var bytes = CryptoJS.AES.decrypt(
      roldeId || 1,
      "J8Lw2Be[CdBZhf/!3?}973Z5O'uNtY4N"
    );
    var originalText = bytes.toString(CryptoJS.enc.Utf8);

    return originalText;
  };

  return {
    ErrorHanlder,
    UserRole,
  };
};

export default Helper();
